import { CustomerType } from 'store/customers/customer';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { IndividualType } from 'store/individuals/individual';
import { SortDirection } from 'utils/tableHelpers';
import { TeamsSortParams } from 'views/teams/useTeamsFilters';

export type ListTeamsResponse = {
    payload: {
        list: Team[];
        pageNumber: number;
        pageSize: number;
        total: number;
    };
    category: string;
    code: string;
    message: string;
};

export type SingleTeamResponse = {
    payload: Team;
    category: string;
    code: string;
    message: string;
};

export type TeamMembership = {
    id: string;
    teamId: string;
    teamName: string;
    role: IndividualType;
};

export type GetTeamsParams = Partial<{
    sortDirection: SortDirection;
    page: number;
    size: number;
    name: string;
    teamManager: string;
    market: DeclarationCountry;
    query: string;
    status: TeamStatuses;
    teamSortParameter: TeamsSortParams;
}>;

export type TeamIndividualResponse = {
    id: string;
    fullName: string;
    address: {
        addressLine1: string;
        addressLine2: string;
        postCode: string;
        city: string;
        country: string;
    };
    phone: string;
    type: string;
    email: string;
    customerId: string;
    teamMemberships: TeamMembership[];
    active: true;
    registered: true;
    darkTheme: true;
    lastLogin: string;
    createdAt: string;
    hasHmrcToken: true;
    referenceNumber: string;
    profilePictureLink: string;
    profilePictureStatus: string;
};

export type TeamMemberResponse = {
    id: string;
    individual: TeamIndividualResponse;
    role: IndividualType;
};

export enum TeamStatuses {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export type Team = {
    id: string;
    name: string;
    members: TeamMemberResponse[];
    market: DeclarationCountry;
    customers: number;
    brokerId: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    status: TeamStatuses;
};

export type CreateUpdateTeamPayload = {
    name: string;
    market: DeclarationCountry;
    teamManager?: string; // individual id
};

export type AddTeamMemberPayload = {
    teamId: string;
    individualId: string;
    role: IndividualType;
};

export type ListCustomersOfTeamsSortParams = 'ID' | 'NAME' | 'TYPE' | 'REFERENCE_CODE';
